import React from 'react';
import { FadeIn } from './ui/FadeIn';
import { CheckCircle2, Compass, Heart, Apple, ShieldAlert, Sparkles } from 'lucide-react';
export function ContentSection() {
  const contents = [{
    icon: <Compass className="w-6 h-6 text-sage" data-id="element-53" />,
    title: 'Entiende tu proceso',
    desc: 'Ideas claras para comprender qué le pasa a tu cuerpo sin tecnicismos médicos que asustan.'
  }, {
    icon: <Sparkles className="w-6 h-6 text-sage" data-id="element-54" />,
    title: 'Hábitos sanadores',
    desc: 'Pequeños cambios diarios que marcan una gran diferencia en la gestión del dolor.'
  }, {
    icon: <ShieldAlert className="w-6 h-6 text-sage" data-id="element-55" />,
    title: 'Errores a evitar',
    desc: 'Las trampas comunes en las que caemos por desesperación y cómo esquivarlas.'
  }, {
    icon: <Heart className="w-6 h-6 text-sage" data-id="element-56" />,
    title: 'Herramientas mentales',
    desc: 'Estrategias para gestionar la frustración, el miedo y los días donde el dolor vuelve.'
  }, {
    icon: <Apple className="w-6 h-6 text-sage" data-id="element-57" />,
    title: 'Enfoque integral',
    desc: 'Cómo el movimiento, la mente y la alimentación se conectan en tu recuperación.'
  }, {
    icon: <CheckCircle2 className="w-6 h-6 text-sage" data-id="element-58" />,
    title: 'Recuperación progresiva',
    desc: 'Un marco de trabajo realista para volver a moverte con confianza paso a paso.'
  }];
  return <section className="py-24 bg-warm-bg" data-id="element-59">
      <div className="max-w-6xl mx-auto px-6" data-id="element-60">
        <FadeIn className="text-center mb-16" data-id="element-61">
          <h2 className="text-3xl md:text-5xl font-heading text-warm-dark mb-6" data-id="element-62">
            ¿Qué encontrarás dentro?
          </h2>
          <p className="text-lg text-warm-dark/70 max-w-2xl mx-auto" data-id="element-63">
            Un recorrido estructurado y compasivo diseñado para leerse a tu
            propio ritmo.
          </p>
        </FadeIn>

        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8" data-id="element-64">
          {contents.map((item, index) => <FadeIn key={index} delay={index * 0.1} className="bg-white p-8 rounded-2xl shadow-sm border border-warm-alt/50 hover:border-sage/30 transition-colors" data-id="element-65">
              <div className="w-12 h-12 bg-sage/10 rounded-xl flex items-center justify-center mb-6" data-id="element-66">
                {item.icon}
              </div>
              <h3 className="text-xl font-medium text-warm-dark mb-3" data-id="element-67">
                {item.title}
              </h3>
              <p className="text-warm-dark/70 leading-relaxed" data-id="element-68">{item.desc}</p>
            </FadeIn>)}
        </div>
      </div>
    </section>;
}